import { Box, CircularProgress } from "@mui/material";
import React from "react";

export const CircularProgressSize = {
  small: 24,
  medium: 36,
  large: 48,
};

const CircularProgressBar = ({ size = CircularProgressSize.medium }) => {
  return (
    <Box
      className="mx-auto"
      style={{
        display: "flex",
        justifyContent: "center",
      }}
    >
      <CircularProgress
        size={size}
        sx={{
          color: "red",
        }}
      />
    </Box>
  );
};

export default CircularProgressBar;
